import React from 'react';
import XeroInstruction from './XeroInstruction';
import { FORM_IDS, INTEGRATION_CONSTANTS, SOURCE_CONSTANTS } from '../constants';
import { getXeroUrl, connectToXero, disconnectToXero, getLoadImportData, getFormAndTaxYearList, getFormSetting } from './XeroSaga';
import { componentKey as xeroComponentKey } from './XeroSlice';
import { INTEGRATION_ROUTES } from '../../../constants/constants';
import XeroZohoFreshBooksSuiteCommonComponent from '../component/xerozohofreshbookssuitecommoncomponent/XeroZohoFreshBooksSuiteCommonComponent';
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks';

const sagaActions = {
    getServiceUrl: getXeroUrl,
    connectToService: connectToXero,
    disconnectToService: disconnectToXero,
    getLoadImportData,
    getFormAndTaxYearList,
    getFormSetting,
};

export default function Xero() {
    useGarbageCollector(xeroComponentKey);
    const breadcrumbsItems = [
        { text: 'Home', link: '/' },
        { text: 'Import', link: `/${INTEGRATION_ROUTES.IMPORT}` },
        { text: 'Xero' }
    ];

    return (
        <XeroZohoFreshBooksSuiteCommonComponent
            sagaActions={sagaActions}
            componentKey={xeroComponentKey}
            instructionsComponent={XeroInstruction}
            integrationConstants={{
                URL_CODE: INTEGRATION_CONSTANTS.URL_CODE,
                URL_SCOPE: INTEGRATION_CONSTANTS.URL_SCOPE,
                URL_ERROR: INTEGRATION_CONSTANTS.URL_ERROR,
                URL_ERROR_DESCRIPTION: INTEGRATION_CONSTANTS.URL_ERROR_DESCRIPTION,
            }}
            sourceConstant={SOURCE_CONSTANTS.XERO_SOURCE}
            breadcrumbsItems={breadcrumbsItems}
        />
    );
}
